import Vue from 'vue';
import Component from 'vue-class-component';

@Component({
  props: {
    option: {
      type: Object,
      required: true,
    },
    homeOption: {
      type: Boolean,
      default: false,
    },
    results: {
      type: Boolean,
      default: false,
    },
    id: {
      type: Number,
      required: false,
    },
  },
})
export default class OptionCardComponent extends Vue {
  get showSearchResults() {
    return Boolean(this.$route.query.keywords);
  }
}
